if (!customElements.get('plyr-player')) {
  class PlyrPlayer extends HTMLElement {
    constructor() {
      super();
      
      this.autoplay = this.dataset.videoAutoplay === 'true';
      this.controls = this.dataset.videoControls === 'true';
      this.mqlSmall = window.matchMedia('screen and (max-width: 749px)');
      
      if (typeof Plyr !== "undefined")
        this.initializePlayer();
      
    }
  
    initializePlayer() {
      const plyrPlayerElement = this.querySelector('[data-plyr-player]');
      const plyrPlayerId = plyrPlayerElement.id;
      
      let cfg = {
        fullscreen: {
          enabled: true, 
          fallback: true, 
          iosNative: true, 
          container: null
        }
      };

      if (this.autoplay) {
        Object.assign(cfg, {
          autoplay: true,
          fullscreen: {
            enabled: false,
            fallback: false, 
            iosNative: false, 
            container: null
          },
          loop: {
            active: true  
          },
          muted: true
        });
      };

      if (!this.controls) {
        Object.assign(cfg, {
          controls: []
        });
      };

      if (
        this.mqlSmall.matches &&
        this.hasAttribute('data-video-mobile')
      ) {
        plyrPlayerElement
          .setAttribute('data-plyr-embed-id', this.dataset.videoMobile);
      }

      const plyrPlayerEmbedId = plyrPlayerElement.dataset.plyrEmbedId;
      let plyrPlayerVideoUrl = `https://vimeo.com/${plyrPlayerEmbedId}`;
      if (plyrPlayerElement.dataset.plyrProvider === 'youtube') plyrPlayerVideoUrl = `https://www.youtube.com/watch?v=${plyrPlayerEmbedId}`;
        
      const plyrPlayer = new Plyr(`#${plyrPlayerId}`, cfg);
      plyrCustomEvents.addEvents(plyrPlayer);
      
      window.plyrInstances = window.plyrInstances || [];
      window.plyrInstances.push({
        id: plyrPlayerId,
        url: plyrPlayerVideoUrl,
        player: plyrPlayer
      });
    }
  }
  
  customElements.define('plyr-player', PlyrPlayer);
}